import { combineReducers } from 'redux';
import detailsReducer from './details';
import searchInvoiceReducer from './invoices';

const customerAreaReducer = combineReducers({
  details: detailsReducer,
  searchInvoice: searchInvoiceReducer,
});

export default customerAreaReducer;
